var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBinance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_898_16114)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z",
    fill: "#F3BA2F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.145 18.005L20 13.15L24.8575 18.0075L27.6825 15.1825L20 7.5L12.32 15.18L15.145 18.005ZM7.5 20L10.325 17.175L13.15 20L10.325 22.825L7.5 20ZM15.145 21.995L20 26.85L24.8575 21.9925L27.6825 24.8162L20 32.5L12.32 24.82L12.3162 24.8162L15.145 21.995ZM26.85 20L29.675 17.175L32.5 20L29.675 22.825L26.85 20ZM22.865 19.9975H22.8675V20L20 22.8675L17.1362 20.005L17.1313 20L17.1362 19.9963L17.6375 19.4938L17.8813 19.25L20 17.1325L22.8662 19.9987L22.865 19.9975Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_898_16114"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBinance);
export default __webpack_public_path__ + "static/media/BINANCE.3f3d4f123bc723bb884a3d551b6878d2.svg";
export { ForwardRef as ReactComponent };